import React, { useMemo } from 'react';

import { Container, Jumbotron } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { Footer, WisaFooterItem } from '@oceanjs/wisa';


/**
 * no react-intl available
 */
export const IE11: React.FC = () => {
  const items: WisaFooterItem[] = useMemo(() => {
    return [
      { messageId: 'wisa.app.footer.home', link: '#/' },
      { messageId: 'wisa.app.footer.imprint', link: 'https://info.bml.gv.at/themen/wasser/wisa/impressum.html', target: '_blank' },
      { messageId: 'wisa.app.footer.privacy', link: '#/privacy' },
      { messageId: 'wisa.app.footer.accessibility', link: '#/accessibility' },
      { messageId: 'wisa.app.footer.helpdesk', link: '#/helpdesk' }
    ]
  },[]);
  return (
    <>
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <h1 className="display-3 mr-3 d-inline">
          <FontAwesomeIcon icon={faCoins} className="mr-5" />
          Parametercodierung
        </h1>
        <p className="lead mt-4">
        Eine Datenbank mit einer konsistenten Parameterliste, welche von allen Beteiligten in allen Teilsystemen genutzt werden kann.
        </p>
        <h2 className="display-5 mt-8">Internet Explorer wird nicht unterstützt.</h2>
        <p>Verwenden Sie einen aktuellen Browser, um mit dieser Anwendung arbeiten zu können.</p>
      </Container>
    </Jumbotron>
    
    </>
  );
};
